import { IPieProps, IPieStyles } from './Pie.types';

export const getStyles = (props: IPieProps): IPieStyles => {
  return {
    root: {},
  };
};
